enum PriceType {
    ONE_TIME = 'one_time',
    RECURRING = 'recurring',
}

export default PriceType;
